import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import { rootReducer } from "../logic/reducers/rootReducer";
import { batchedSubscribe } from "redux-batched-subscribe";
import { unstable_batchedUpdates } from "react-dom";
import { gtmMiddleware } from "./analytics/gtm";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancers(
  applyMiddleware(thunkMiddleware, gtmMiddleware),
  batchedSubscribe(unstable_batchedUpdates),
);

const store = createStore(
  rootReducer,
  /* preloadedState, */
  enhancer,
);

export { store };

/*export const store = createStore(rootReducer, 
    //preloadedState, 
    composeEnhancers(
        applyMiddleware(
            thunkMiddleware,
        )
    )
);*/
